module.exports = __webpack_public_path__ + "img/pr-1.e5bb378b.png";